(function () {
    'use strict';
    var m = angular.module('common');
    m.directive('tinymce', ["$timeout", "$sanitize", function ($timeout, $sanitize) {
        return {
            restrict: 'A',
            replace: false,
            scope: {
                options: '=tinymce',
                model: '=tinymceModel'
            },
            link: function ($scope, element, attrs) {
                var lastContent;
                var ed = null;
                var options = $.extend({ convert_urls: false }, $scope.options, {
                    setup: function (editor) {
                        editor.on('change undo redo blur keyup mouseleave', function (e) {
                            $timeout(function () {
                                lastContent = $scope.model = editor.getContent();
                            });
                        });
                        if (_($scope.options.setup).isFunction()) {
                            $scope.options.setup(editor);
                        }
                        editor.on('click', function (e) {
                            $(element).trigger('click');
                        });
                    },
                    init_instance_callback: function (editor) {
                        ed = editor;
                        ed.setContent($sanitize($scope.model));
                    }
                });
                element.tinymce(options);
                $scope.$watch('model', function (model) {
                    if (ed && model != lastContent) {
                        lastContent = model;
                        ed.setContent($sanitize($scope.model));
                    }
                });
            }
        };
    }]);
}());